import { Component, OnInit } from '@angular/core';
import { PageBaseComponent } from './page-base.component';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService, DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { PagerSettings } from "@progress/kendo-angular-listview";
import { environment } from '@environments/environment';


@Component({
  selector: 'vehicles',
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-list.css'],    
  template: `

    <div class="wrapper-route">
    
      <div class="row" style="padding-bottom: 8px;">        
        <div class="col-xs-12 col-sm-12 example-col">
          <kendo-textbox [clearButton]="true" (valueChange)="onSearchChange($event)" style="width: 100%">
            <ng-template kendoTextBoxPrefixTemplate>
              <button kendoButton look="clear" icon="search"></button>
              <kendo-textbox-separator></kendo-textbox-separator>
            </ng-template>
            <ng-template kendoTextBoxSuffixTemplate>
              <vehicle-filter (selected)="onSelected($event)"></vehicle-filter>
            </ng-template>
          </kendo-textbox>
        </div>
      </div>

      <div class="row" style="padding-bottom: 8px; padding-left: 12px; padding-top: 4px;" *ngIf="!loading && data.length == 0">        
        <div class="col-xs-12 col-sm-12 example-col list-header" style="text-align: center">
          <kendo-label text="Sin resultados."></kendo-label>
        </div>
      </div>

      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div>    

      <kendo-listview [kendoListViewBinding]="data" [pageable]="pagerSettings" [pageSize]="pageSize" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!loading && data.length">
        <ng-template kendoListViewHeaderTemplate>
          <div class="list-header">Lista de vehículos</div>
        </ng-template>
        <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
          <vehicle-card class="card" [vehicle]="dataItem" [returnUrl]="'vehicles'" [borderTop]="!isFirst"></vehicle-card>
        </ng-template>
        <!--<ng-template kendoListViewFooterTemplate>
          <div class="list-footer">{{total}} productores</div>
        </ng-template>-->
      </kendo-listview>

    </div>

  `
})
export class VehiclesComponent extends PageBaseComponent implements OnInit {

  public data: any[];

  public total: number;

  public pagerSettings: PagerSettings = {
    previousNext: true,
    pageSizeValues: false,
    buttonCount: 9,
  };

  public pageSize = 10;

  public defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  protected id_tecnico: number = 0;

  protected id_vehicle_status: number = 0;

  protected search: string = '';

  protected searchColumns: any[] = [
    'authority_abbreviation',    
    'authority_name',    
    'color',
    'deposit_name',
    'entry_date',
    'marck',
    'place',
    'plaque',
    'serie',
    'sku_exp',
    'sku_inv'
  ];


  constructor(public authService: AuthService, protected router: Router, protected service : DatasourceService, private http: HttpClient) { 

    super(authService, router)
    this.id_tecnico = this.currentUser.id;
    // console.log('VehiclesComponent');

  }

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.take = 0;
    s.sort = [      
      {field: 'sku_exp', dir: 'desc'}
    ];
    s.filter = {
      logic: "and",
      filters: []
    }

    if(this.id_vehicle_status != 0){
      s.filter.filters.push(
        {
          field: 'id_vehicle_status',
          operator: 'eq',
          value: this.id_vehicle_status
        }
      )
    }

    if(this.search != ''){      
      s.filter.filters.push(
        {
          logic: "or",
          filters: this.searchColumns.map(item => {
            return {
              field: item,
              operator: 'contains',
              value: this.search
            }
          })
        }
      )
    }

    return s;

  }

  ngOnInit() { 
    
    // this.state = this.getInitialState();
    // this.loading = true;
    this.update(0)

  }

  public onSelected(event: any) {

    console.log(event);

    this.update(event.dataItem.id);

  }

  public onSearchChange(value: any): void {

    this.search = value;

    this.update(this.id_vehicle_status);    

  }

  public update(id_vehicle_status: number) {

    this.loading = true;

    this.id_vehicle_status = id_vehicle_status;

    this.state = this.getInitialState();

    this.service.search('vehicles_inventories', this.state)
      .subscribe(
        (result: any) => {
          console.log(result);
          this.data = result.data;
          this.total = result.total;

          this.loading = false;
        },
        (error: any) => {
            console.log(error)
            // this.loading = false;
        });

  }  

}